// @flow

import _ from 'lodash';
import ApiObject from './ApiObject';
import Timelapse from './Timelapse';
import Payin from './Payin';

export default class PayinList extends ApiObject {

  timelapse: Timelapse = new Timelapse();

  payins: Array<Payin> = []; // Array of Payin

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize timelapse
    this.timelapse = new Timelapse();
    this.timelapse.setFromTime(data.fromTime / 1000);
    this.timelapse.setToTime(data.toTime / 1000);

    // -- deserialize payins
    this.payins = [];

    _.each(data.payins, (payinData:Object) => {
      const payin:Payin = new Payin();
      payin.fromJson(payinData);
      this.payins.push(payin);
    });
  }
}
